import { Fragment, useState } from 'react';
import {
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Table,
  TableHead,
} from '@mui/material';
import MuiRadioGroup from './components/MuiRadioGroup';

import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';
import { StyledTableCellTwo } from 'routes/Main/style';
import { Box, Stack, useTheme } from '@mui/system';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const Contents = (props: Props) => {
  const { disabled, getValues, setValue } = props;
  const { palette } = useTheme();

  const [num01, setNum01] = useState(
    getValues('kdsq_p_01') ? getValues('kdsq_p_01') : 0
  );
  const [num02, setNum02] = useState(
    getValues('kdsq_p_02') ? getValues('kdsq_p_02') : 0
  );
  const [num03, setNum03] = useState(
    getValues('kdsq_p_03') ? getValues('kdsq_p_03') : 0
  );
  const [num04, setNum04] = useState(
    getValues('kdsq_p_04') ? getValues('kdsq_p_04') : 0
  );
  const [num05, setNum05] = useState(
    getValues('kdsq_p_05') ? getValues('kdsq_p_05') : 0
  );

  return (
    <Fragment>
      <Typography
        sx={{ fontSize: '12px', fontWeight: 400, margin: '38px 0px 0px 20px' }}
      >
        아래의 각 항목에 대하여, 1년 전과 비교하여 현재 상태에 해당하는 곳에
        표시해 주십시오. (동행한 가족이 있으면 가족이 작성하시고, 없으면 본인이
        작성하십시오.)
      </Typography>
      <SectionTitle title="KDSQ-P(Prescreening Korean Dementia Screening Questionnaries)" />

      <Grid item xs={12}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  whiteSpace: 'nowrap',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  fontSize: '12px',
                  paddingLeft: '30px',
                }}
              >
                <Stack direction="row" gap={16.5}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    아니다(0점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    가끔 그렇다(1점)
                  </Typography>
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                    자주 그렇다(2점)
                  </Typography>
                </Stack>
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  1. 자신의 기억력이 친구나 동료들에 비해 못하다고 생각하십니까?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_p_01')}
                  onChange={v => {
                    setValue('kdsq_p_01', Number(v));
                    setNum01(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                  maxHeight={50}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  2. 자신의 기억력이 1년 전에 비해 더 나빠졌다고 생각하십니까?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_p_02')}
                  onChange={v => {
                    setValue('kdsq_p_02', Number(v));
                    setNum02(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  3. 중요한 일을 하는데 있어서도 기억력이 문제가 되는 경우가
                  있습니까?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_p_03')}
                  onChange={v => {
                    setValue('kdsq_p_03', Number(v));
                    setNum03(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  4. 자신의 기억력이 떨어진 것을 남들도 알고 있습니까?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_p_04')}
                  onChange={v => {
                    setValue('kdsq_p_04', Number(v));
                    setNum04(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    width: '500px',
                  }}
                  maxHeight={20}
                  display="block"
                  variant="caption"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace={'pre-line'}
                >
                  5. 잘해오던 일상적인 일을 하는데 예전보다 서툴러졌다고
                  생각하십니까?
                </Typography>
              </TableCell>
              <TableCell sx={{ textAlign: 'left', paddingLeft: '50px' }}>
                <MuiRadioGroup
                  disabled={disabled}
                  values={[0, 1, 2]}
                  defaultValue={getValues('kdsq_p_05')}
                  onChange={v => {
                    setValue('kdsq_p_05', Number(v));
                    setNum05(Number(v));
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-end'}>
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            합계 : {num01 + num02 + num03 + num04 + num05}점
          </Typography>
          <Typography
            minWidth={115}
            variant="caption"
            sx={{ color: `${palette.primary.main}`, marginTop: '30px' }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5} sx={{ fontSize: '13px' }}>
                4점 이상인 경우 치매 선별 검사가 필요한 대상자로 판단됩니다.
              </Box>
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default Contents;
